
interface BrandLogoProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export default function BrandLogo({ size = 'medium', className = '' }: BrandLogoProps) {
  const sizeClasses = {
    small: 'text-xs md:text-sm',
    medium: 'text-sm md:text-base lg:text-lg',
    large: 'text-base md:text-lg lg:text-xl'
  };

  const titleSizeClasses = {
    small: 'text-lg md:text-xl',
    medium: 'text-xl md:text-2xl lg:text-3xl',
    large: 'text-2xl md:text-3xl lg:text-4xl'
  };

  const descriptorSizeClasses = {
    small: 'text-xs md:text-sm',
    medium: 'text-sm md:text-base',
    large: 'text-base md:text-lg'
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      {/* Arabic Text - Top */}
      <div 
        className={`text-[#D23B34] font-bold ${sizeClasses[size]} mb-2 text-center leading-tight filter drop-shadow-lg`}
        style={{ fontFamily: 'Tajawal, Cairo, sans-serif' }}
        dir="rtl"
      >
        فلامي جارد للتجارة والخدمات
      </div>
      
      {/* English Brand Name - Below */}
      <div 
        className={`gradient-text font-extrabold ${titleSizeClasses[size]} mb-2 text-center leading-tight filter drop-shadow-lg`}
        style={{ fontFamily: 'Montserrat, sans-serif' }}
      >
        FLAME GUARD
      </div>
      
      {/* Descriptor - Bottom */}
      <div 
        className={`text-white font-medium ${descriptorSizeClasses[size]} tracking-wider text-center leading-tight filter drop-shadow-lg`}
        style={{ fontFamily: 'Montserrat, sans-serif' }}
      >
        TRADING AND SERVICES
      </div>
    </div>
  );
}
